import { EvoMfeApp } from '@access-evo/evo-api';
import { EvoIframeMfesProvider } from '@access-evo/mfe-react-host';
import { LoadingScreen } from '@/components/LoadingScreen';
import { useAuth } from '@/providers/AuthProvider';
import { usePaySuiteConfig } from '@/providers/PaySuiteConfigProvider';

const CREDIT_CONTROL_APPLICATION_ID = 'd1a45014-f485-4817-8c02-5243395572fd';

interface PaySuiteMfePageProps {
  title: string;
  description: string;
  componentName: string;
  instanceId: string;
}

/** Reusable page shell for rendering a PaySuite MFE via the EvoMfeApp component orchestrator. */
export default function PaySuiteMfePage({
  title,
  description,
  componentName,
  instanceId: mfeInstanceId,
}: PaySuiteMfePageProps) {
  const { instanceId } = useAuth();
  const { orchestratorName } = usePaySuiteConfig();

  if (!instanceId) {
    return <LoadingScreen />;
  }

  return (
    <div className="flex-1 space-y-4 p-4 md:p-6 pt-6">
      <div>
        <h2 className="text-3xl font-bold tracking-tight">{title}</h2>
        <p className="text-muted-foreground">{description}</p>
      </div>
      <EvoIframeMfesProvider>
        <EvoMfeApp
          instanceId={mfeInstanceId}
          name={orchestratorName}
          version="x.x.x"
          parameters={{
            componentName,
            componentVersion: 'x.x.x',
            applicationId: CREDIT_CONTROL_APPLICATION_ID,
            applicationSubscriptionId: instanceId,
          }}
        />
      </EvoIframeMfesProvider>
    </div>
  );
}
